<script>
  import { onMount } from "svelte";
  import MenuButton from "@/components/atoms/MenuButton.svelte";
  import Menu from "./menu.svelte";
  import * as PropTypes from "prop-types";
  import trackEvents from "@/events";
  import ImageUrls from "@/constants/ImageUrls";
  
  const { checkPropTypes, string, array, bool } = PropTypes;

  export let theme;
  export let headerLinks = [];
  export let source = "";
  export let isIframe = false;
  export let homeRoute = "/short-video-app";
  const hasForcedTheme = theme !== undefined;
  const linkAttrs = isIframe ? { target: "_parent" } : {};
  let opened = false;

  const setOpened = (val) => {
    opened = val;
  };
  const onClickHandler = () => {
    setOpened(!opened);
  };
  const propTypes = {
    theme: string,
    headerLinks: array,
    isIframe: bool,
    homeRoute: string,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "WikiHeader");
    const handleResize = () => {
      if (opened && window.innerWidth > 900) {
        setOpened(false);
      }
    };
    window.addEventListener("resize", handleResize);
  });
  const eventsHandler = (link) => {
    if (link.n === "Download App") {
      trackEvents("DownloadAppButton", {
        source,
      });
    }
  };
</script>

<header
  data-cy="header"
  class="relative w-full max-w-[1200px] mx-auto py-md px-md md:px-xxl flex justify-between items-center z-10"
>
  <a class="block" href={homeRoute} {...linkAttrs} data-testid="moj-logo">
    <img
      src={`/assets/png/Moj_logo.png`}
      srcset={`/assets/png/Moj_logo.png 1x, /assets/png/Moj_logo@2x.png 2x`}
      alt="Moj"
      width="50"
      height="30"
      class={hasForcedTheme
        ? `${theme === "dark" ? "hidden" : "block"}`
        : `block dark:hidden`}
    />
    <img
      src={ImageUrls.MOJ_LOGO}
      srcset={`${ImageUrls.MOJ_LOGO} 1x, ${ImageUrls.MOJ_LOGO_2X} 2x`}
      alt="Moj"
      width="50"
      height="30"
      class={hasForcedTheme
        ? `${theme === "dark" ? "block" : "hidden"}`
        : `hidden dark:block`}
    />
  </a>

  <div class="hidden md:flex">
    {#each headerLinks as link (link.r)}
      <a
        on:click={() => {
          eventsHandler(link);
        }}
        href={link.r}
        class={`${
          hasForcedTheme
            ? `${theme === "dark" ? "text-white" : "text-black"}`
            : `text-black dark:text-white`
        } font-semibold px-sm`}
        target={link.nt === 1 ? "_blank" : ""}
        {...linkAttrs}>{link.n}</a
      >
    {/each}
  </div>

  {#if headerLinks.length > 0}
    <div class="block md:hidden" on:click={onClickHandler}>
      <MenuButton {opened} {theme} />
    </div>
  {/if}
</header>

{#if headerLinks.length > 0}
  <Menu navLinks={headerLinks} {opened} {theme} />
{/if}
